export const STATUS_COLORS = {
  success: '#46d281',
  warning: '#ffac2c',
  error: '#e12845',
  info: '#275ffd',
} as const

export const BRAND_COLORS = {
  red: '#ff4b33',
  ink: '#464646',
  paper: '#f2f2f2',
  border: '#dddddd',
  pinkTint: '#fbd7dd',
} as const

export type StatusColor = keyof typeof STATUS_COLORS
